import { EntityList } from "./EntityList";
import { EntityShow } from "./EntityShow";

export default {
  list: EntityList,
  show: EntityShow,
};
